/* Warenkorb-Empfehlung (Goldi 05.10.2026): „Hinzufügen“ legt den Vorschlag in den Warenkorb und rendert die Ella-Schublade neu. */
if (!window.__cartEmpBound) {
  window.__cartEmpBound = true;
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-cart-emp-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    btn.disabled = true;
    btn.classList.add('loading');
    const drawer = document.querySelector('cart-drawer');
    const root = window.Shopify?.routes?.root || '/';
    const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (drawer?.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (data.status && data.description) throw new Error(data.description);
      if (drawer?.renderContents && data.sections) await drawer.renderContents(data);
      else window.location.href = `${root}cart`;
      document.dispatchEvent(new CustomEvent('mixmatch:cart-changed'));
    } catch (e) {
      window.alert(e.message || 'Das hat leider nicht geklappt. Bitte versuch es nochmal.');
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  });
}
